import imageUrlFromSignedBlobId from "Shared/functions/imageUrlFromSignedBlobId"

export default function convertImageTemplateFields(templateFields = [], fieldValues = {}) {
    return _.mapValues(fieldValues, (value, key) => {
    const field = templateFields.find(f => f.slug === key)
    if (!field) return value
    if (!value) return value

    if (field.image) {
      if (value.includes('https://') || value.includes('data:image/webp;base64')) {
        var src = value
      } else {
        var src = imageUrlFromSignedBlobId(value)
      }

      return `<img src="${src}" alt="${field.label}" />`
    }

    return value
  })
}
